"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getFocusableElements(t) {
  return Array.from(t.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll('[id^="Details-"] summary').forEach(function (t) {
  t.setAttribute("role", "button"), t.setAttribute("aria-expanded", t.parentNode.hasAttribute("open")), t.nextElementSibling.getAttribute("id") && t.setAttribute("aria-controls", t.nextElementSibling.id), t.addEventListener("click", function (t) {
    t.currentTarget.setAttribute("aria-expanded", !t.currentTarget.closest("details").hasAttribute("open"));
  }), t.closest("header-drawer, menu-drawer") || t.parentElement.addEventListener("keyup", onKeyUpEscape);
});
var trapFocusHandlers = {};
function trapFocus(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
  var i = getFocusableElements(e),
    s = i[0],
    n = i[i.length - 1];
  removeTrapFocus(), trapFocusHandlers.focusin = function (t) {
    t.target !== e && t.target !== n && t.target !== s || document.addEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.keydown = function (t) {
    "TAB" === t.code.toUpperCase() && (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()), t.target === e || t.target === s) && t.shiftKey && (t.preventDefault(), n.focus());
  }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), t.focus(), "INPUT" === t.tagName && ["search", "text", "email", "url"].includes(t.type) && t.value && t.setSelectionRange(0, t.value.length);
}
try {
  document.querySelector(":focus-visible");
} catch (t) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  var e = ["ARROWUP", "ARROWDOWN", "ARROWLEFT", "ARROWRIGHT", "TAB", "ENTER", "SPACE", "ESCAPE", "HOME", "END", "PAGEUP", "PAGEDOWN"];
  var t = null,
    i = null;
  window.addEventListener("keydown", function (t) {
    e.includes(t.code.toUpperCase()) && (i = !1);
  }), window.addEventListener("mousedown", function (t) {
    i = !0;
  }), window.addEventListener("focus", function () {
    t && t.classList.remove("focused"), i || (t = document.activeElement).classList.add("focused");
  }, !0);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(function (t) {
    t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
  }), document.querySelectorAll(".js-vimeo").forEach(function (t) {
    t.contentWindow.postMessage('{"method":"pause"}', "*");
  }), document.querySelectorAll("video").forEach(function (t) {
    return t.pause();
  }), document.querySelectorAll("product-model").forEach(function (t) {
    t.modelViewerUI && t.modelViewerUI.pause();
  });
}
function removeTrapFocus() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), t && t.focus();
}
function onKeyUpEscape(t) {
  var e;
  "ESCAPE" === t.code.toUpperCase() && (t = t.target.closest("details[open]")) && (e = t.querySelector("summary"), t.removeAttribute("open"), e.setAttribute("aria-expanded", !1), e.focus());
}
var QuantityInput = /*#__PURE__*/function (_HTMLElement) {
  function QuantityInput() {
    var _this;
    _classCallCheck(this, QuantityInput);
    (_this = _callSuper(this, QuantityInput), _defineProperty(_assertThisInitialized(_this), "quantityUpdateUnsubscriber", void 0)), _this.input = _this.querySelector("input"), _this.changeEvent = new Event("change", {
      bubbles: !0
    }), _this.input.addEventListener("change", _this.onInputChange.bind(_assertThisInitialized(_this))), _this.querySelectorAll("button").forEach(function (t) {
      return t.addEventListener("click", _this.onButtonClick.bind(_assertThisInitialized(_this)));
    });
    return _this;
  }
  _inherits(QuantityInput, _HTMLElement);
  return _createClass(QuantityInput, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.validateQtyRules(), this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(t) {
      this.validateQtyRules();
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(t) {
      t.preventDefault();
      var e = this.input.value;
      "plus" === t.target.name ? this.input.stepUp() : this.input.stepDown(), e !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
  }, {
    key: "validateQtyRules",
    value: function validateQtyRules() {
      var t,
        e = parseInt(this.input.value);
      this.input.min && (t = parseInt(this.input.min), this.querySelector(".quantity__button[name='minus']").classList.toggle("disabled", e <= t)), this.input.max && (t = parseInt(this.input.max), this.querySelector(".quantity__button[name='plus']").classList.toggle("disabled", t <= e));
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
function debounce(e, i) {
  var _this2 = this;
  var s;
  return function () {
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }
    clearTimeout(s), s = setTimeout(function () {
      return e.apply(_this2, t);
    }, i);
  };
}
function throttle(i, s) {
  var n = 0;
  return function () {
    var e = new Date().getTime();
    if (!(e - n < s)) return n = e, i.apply(void 0, arguments);
  };
}
function fetchConfig() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "json";
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + t
    }
  };
}
customElements.define("quantity-input", QuantityInput), void 0 === window.Shopify && (window.Shopify = {}), Shopify.bind = function (t, e) {
  return function () {
    return t.apply(e, arguments);
  };
}, Shopify.setSelectorByValue = function (t, e) {
  for (var i = 0, s = t.options.length; i < s; i++) {
    var n = t.options[i];
    if (e == n.value || e == n.innerHTML) return t.selectedIndex = i;
  }
}, Shopify.addListener = function (t, e, i) {
  t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i);
}, Shopify.postLink = function (t, e) {
  var i,
    s = (e = e || {}).method || "post",
    n = e.parameters || {},
    r = document.createElement("form");
  for (i in r.setAttribute("method", s), r.setAttribute("action", t), n) {
    var o = document.createElement("input");
    o.setAttribute("type", "hidden"), o.setAttribute("name", i), o.setAttribute("value", n[i]), r.appendChild(o);
  }
  document.body.appendChild(r), r.submit(), document.body.removeChild(r);
}, Shopify.CountryProvinceSelector = function (t, e, i) {
  this.countryEl = document.getElementById(t), this.provinceEl = document.getElementById(e), this.provinceContainer = document.getElementById(i.hideElement || e), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince();
}, Shopify.CountryProvinceSelector.prototype = {
  initCountry: function initCountry() {
    var t = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler();
  },
  initProvince: function initProvince() {
    var t = this.provinceEl.getAttribute("data-default");
    t && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, t);
  },
  countryHandler: function countryHandler(t) {
    var e = (s = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
      i = JSON.parse(e);
    if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";else {
      for (var s, n = 0; n < i.length; n++) (s = document.createElement("option")).value = i[n][0], s.innerHTML = i[n][1], this.provinceEl.appendChild(s);
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function clearOptions(t) {
    for (; t.firstChild;) t.removeChild(t.firstChild);
  },
  setOptions: function setOptions(t, e) {
    var i = 0;
    for (e.length; i < e.length; i++) {
      var s = document.createElement("option");
      s.value = e[i], s.innerHTML = e[i], t.appendChild(s);
    }
  }
};
var MenuDrawer = /*#__PURE__*/function (_HTMLElement2) {
  function MenuDrawer() {
    var _this3;
    _classCallCheck(this, MenuDrawer);
    _this3 = _callSuper(this, MenuDrawer), _this3.mainDetailsToggle = _this3.querySelector("details"), _this3.addEventListener("keyup", _this3.onKeyUp.bind(_assertThisInitialized(_this3))), _this3.addEventListener("focusout", _this3.onFocusOut.bind(_assertThisInitialized(_this3))), _this3.bindEvents();
    return _this3;
  }
  _inherits(MenuDrawer, _HTMLElement2);
  return _createClass(MenuDrawer, [{
    key: "bindEvents",
    value: function bindEvents() {
      var _this4 = this;
      this.querySelectorAll("summary").forEach(function (t) {
        return t.addEventListener("click", _this4.onSummaryClick.bind(_this4));
      }), this.querySelectorAll("button:not(.localization-selector)").forEach(function (t) {
        return t.addEventListener("click", _this4.onCloseButtonClick.bind(_this4));
      });
    }
  }, {
    key: "onKeyUp",
    value: function onKeyUp(t) {
      var e;
      "ESCAPE" === t.code.toUpperCase() && (e = t.target.closest("details[open]")) && (e === this.mainDetailsToggle ? this.closeMenuDrawer(t, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(e));
    }
  }, {
    key: "onSummaryClick",
    value: function onSummaryClick(t) {
      var e = t.currentTarget,
        i = e.parentNode,
        s = i.closest(".has-submenu");
      var n = i.hasAttribute("open");
      var r = window.matchMedia("(prefers-reduced-motion: reduce)");
      function o() {
        trapFocus(e.nextElementSibling, i.querySelector("button")), e.nextElementSibling.removeEventListener("transitionend", o);
      }
      i === this.mainDetailsToggle ? (n && t.preventDefault(), n ? this.closeMenuDrawer(t, e) : this.openMenuDrawer(e), window.matchMedia("(max-width: 990px)") && document.documentElement.style.setProperty("--viewport-height", window.innerHeight + "px")) : setTimeout(function () {
        i.classList.add("menu-opening"), e.setAttribute("aria-expanded", !0), s && s.classList.add("submenu-open"), !r || r.matches ? o() : e.nextElementSibling.addEventListener("transitionend", o);
      }, 100);
    }
  }, {
    key: "openMenuDrawer",
    value: function openMenuDrawer(t) {
      var _this5 = this;
      setTimeout(function () {
        _this5.mainDetailsToggle.classList.add("menu-opening");
      }), t.setAttribute("aria-expanded", !0), trapFocus(this.mainDetailsToggle, t), document.body.classList.add("overflow-hidden-" + this.dataset.breakpoint);
    }
  }, {
    key: "closeMenuDrawer",
    value: function closeMenuDrawer(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      void 0 !== t && (this.mainDetailsToggle.classList.remove("menu-opening"), this.mainDetailsToggle.querySelectorAll("details").forEach(function (t) {
        t.removeAttribute("open"), t.classList.remove("menu-opening");
      }), this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach(function (t) {
        t.classList.remove("submenu-open");
      }), document.body.classList.remove("overflow-hidden-" + this.dataset.breakpoint), removeTrapFocus(e), this.closeAnimation(this.mainDetailsToggle), t instanceof KeyboardEvent) && (e === null || e === void 0 ? void 0 : e.setAttribute("aria-expanded", !1));
    }
  }, {
    key: "onFocusOut",
    value: function onFocusOut() {
      var _this6 = this;
      setTimeout(function () {
        _this6.mainDetailsToggle.hasAttribute("open") && !_this6.mainDetailsToggle.contains(document.activeElement) && _this6.closeMenuDrawer();
      });
    }
  }, {
    key: "onCloseButtonClick",
    value: function onCloseButtonClick(t) {
      t = t.currentTarget.closest("details");
      this.closeSubmenu(t);
    }
  }, {
    key: "closeSubmenu",
    value: function closeSubmenu(t) {
      var e = t.closest(".submenu-open");
      e && e.classList.remove("submenu-open"), t.classList.remove("menu-opening"), t.querySelector("summary").setAttribute("aria-expanded", !1), removeTrapFocus(t.querySelector("summary")), this.closeAnimation(t);
    }
  }, {
    key: "closeAnimation",
    value: function closeAnimation(e) {
      var i;
      var s = function s(t) {
        t - (i = void 0 === i ? t : i) < 400 ? window.requestAnimationFrame(s) : (e.removeAttribute("open"), e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")));
      };
      window.requestAnimationFrame(s);
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("menu-drawer", MenuDrawer);
var HeaderDrawer = /*#__PURE__*/function (_MenuDrawer) {
  function HeaderDrawer() {
    var _this7;
    _classCallCheck(this, HeaderDrawer);
    _this7 = _callSuper(this, HeaderDrawer);
    _defineProperty(_this7, "onResize", function () {
      _this7.header && document.documentElement.style.setProperty("--header-bottom-position", parseInt(_this7.header.getBoundingClientRect().bottom - _this7.borderOffset) + "px"), document.documentElement.style.setProperty("--viewport-height", window.innerHeight + "px");
    });
    return _this7;
  }
  _inherits(HeaderDrawer, _MenuDrawer);
  return _createClass(HeaderDrawer, [{
    key: "openMenuDrawer",
    value: function openMenuDrawer(t) {
      var _this8 = this;
      this.header = this.header || document.querySelector(".section-header"), this.borderOffset = this.borderOffset || 0, document.documentElement.style.setProperty("--header-bottom-position", parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset) + "px"), this.header.classList.add("menu-open"), setTimeout(function () {
        _this8.mainDetailsToggle.classList.add("menu-opening");
      }), t.setAttribute("aria-expanded", !0), window.addEventListener("resize", this.onResize), trapFocus(this.mainDetailsToggle, t), document.body.classList.add("overflow-hidden-" + this.dataset.breakpoint);
    }
  }, {
    key: "closeMenuDrawer",
    value: function closeMenuDrawer(t, e) {
      e && (_get(_getPrototypeOf(HeaderDrawer.prototype), "closeMenuDrawer", this).call(this, t, e), this.header.classList.remove("menu-open"), window.removeEventListener("resize", this.onResize));
    }
  }]);
}(MenuDrawer);
customElements.define("header-drawer", HeaderDrawer);
var ModalDialog = /*#__PURE__*/function (_HTMLElement3) {
  function ModalDialog() {
    var _this9;
    _classCallCheck(this, ModalDialog);
    _this9 = _callSuper(this, ModalDialog), _this9.querySelector('[id^="ModalClose-"]').addEventListener("click", _this9.hide.bind(_assertThisInitialized(_this9), !1)), _this9.addEventListener("keyup", function (t) {
      "ESCAPE" === t.code.toUpperCase() && _this9.hide();
    }), _this9.classList.contains("media-modal") ? _this9.addEventListener("pointerup", function (t) {
      "mouse" !== t.pointerType || t.target.closest("deferred-media, product-model") || _this9.hide();
    }) : _this9.addEventListener("click", function (t) {
      t.target === _assertThisInitialized(_this9) && _this9.hide();
    });
    return _this9;
  }
  _inherits(ModalDialog, _HTMLElement3);
  return _createClass(ModalDialog, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.moved || (this.moved = !0, document.body.appendChild(this));
    }
  }, {
    key: "show",
    value: function show(t) {
      this.openedBy = t;
      t = this.querySelector(".template-popup");
      document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), t && t.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia();
    }
  }, {
    key: "hide",
    value: function hide() {
      document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")), this.removeAttribute("open"), removeTrapFocus(this.openedBy), window.pauseAllMedia();
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("modal-dialog", ModalDialog);
var ModalOpener = /*#__PURE__*/function (_HTMLElement4) {
  function ModalOpener() {
    var _this10;
    _classCallCheck(this, ModalOpener);
    _this10 = _callSuper(this, ModalOpener);
    var e = _this10.querySelector("button");
    e && e.addEventListener("click", function () {
      var t = document.querySelector(_this10.getAttribute("data-modal"));
      t && t.show(e);
    });
    return _this10;
  }
  _inherits(ModalOpener, _HTMLElement4);
  return _createClass(ModalOpener);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("modal-opener", ModalOpener);
var DeferredMedia = /*#__PURE__*/function (_HTMLElement5) {
  function DeferredMedia() {
    var _this11;
    _classCallCheck(this, DeferredMedia);
    _this11 = _callSuper(this, DeferredMedia);
    var t = _this11.querySelector('[id^="Deferred-Poster-"]');
    t && t.addEventListener("click", _this11.loadContent.bind(_this11));
    return _this11;
  }
  _inherits(DeferredMedia, _HTMLElement5);
  return _createClass(DeferredMedia, [{
    key: "loadContent",
    value: function loadContent() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var e;
      window.pauseAllMedia(), this.getAttribute("loaded") || ((e = document.createElement("div")).appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0), e = this.appendChild(e.querySelector("video, model-viewer, iframe")), t && e.focus(), "VIDEO" == e.nodeName && e.getAttribute("autoplay") && e.play());
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("deferred-media", DeferredMedia);
var SliderComponent = /*#__PURE__*/function (_HTMLElement6) {
  function SliderComponent() {
    var _this12;
    _classCallCheck(this, SliderComponent);
    _this12 = _callSuper(this, SliderComponent), _this12.slider = _this12.querySelector('[id^="Slider-"]'), _this12.sliderItems = _this12.querySelectorAll('[id^="Slide-"]'), _this12.enableSliderLooping = !1, _this12.currentPageElement = _this12.querySelector(".slider-counter--current"), _this12.pageTotalElement = _this12.querySelector(".slider-counter--total"), _this12.prevButton = _this12.querySelector('button[name="previous"]'), _this12.nextButton = _this12.querySelector('button[name="next"]'), _this12.slider && _this12.nextButton && (_this12.initPages(), new ResizeObserver(function (t) {
      return _this12.initPages();
    }).observe(_this12.slider), _this12.slider.addEventListener("scroll", _this12.update.bind(_assertThisInitialized(_this12))), _this12.prevButton.addEventListener("click", _this12.onButtonClick.bind(_assertThisInitialized(_this12))), _this12.nextButton.addEventListener("click", _this12.onButtonClick.bind(_assertThisInitialized(_this12))));
    return _this12;
  }
  _inherits(SliderComponent, _HTMLElement6);
  return _createClass(SliderComponent, [{
    key: "initPages",
    value: function initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (t) {
        return 0 < t.clientWidth;
      }), this.sliderItemsToShow.length < 2 || (this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft, this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset), this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1, this.update());
    }
  }, {
    key: "resetPages",
    value: function resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]'), this.initPages();
    }
  }, {
    key: "update",
    value: function update() {
      var t;
      this.slider && this.nextButton && (t = this.currentPage, this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1, this.currentPageElement && this.pageTotalElement && (this.currentPageElement.textContent = this.currentPage, this.pageTotalElement.textContent = this.totalPages), this.currentPage != t && this.dispatchEvent(new CustomEvent("slideChanged", {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      })), this.enableSliderLooping || (this.isSlideVisible(this.sliderItemsToShow[0]) && 0 === this.slider.scrollLeft ? this.prevButton.setAttribute("disabled", "disabled") : this.prevButton.removeAttribute("disabled"), this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1]) ? this.nextButton.setAttribute("disabled", "disabled") : this.nextButton.removeAttribute("disabled")));
    }
  }, {
    key: "isSlideVisible",
    value: function isSlideVisible(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      e = this.slider.clientWidth + this.slider.scrollLeft - e;
      return t.offsetLeft + t.clientWidth <= e && t.offsetLeft >= this.slider.scrollLeft;
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(t) {
      t.preventDefault();
      var e = t.currentTarget.dataset.step || 1;
      this.slideScrollPosition = "next" === t.currentTarget.name ? this.slider.scrollLeft + e * this.sliderItemOffset : this.slider.scrollLeft - e * this.sliderItemOffset, this.setSlidePosition(this.slideScrollPosition);
    }
  }, {
    key: "setSlidePosition",
    value: function setSlidePosition(t) {
      this.slider.scrollTo({
        left: t
      });
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("slider-component", SliderComponent);
var SlideshowComponent = /*#__PURE__*/function (_SliderComponent) {
  function SlideshowComponent() {
    var _this13;
    _classCallCheck(this, SlideshowComponent);
    _this13 = _callSuper(this, SlideshowComponent), _this13.sliderControlWrapper = _this13.querySelector(".slider-buttons"), _this13.enableSliderLooping = !0, _this13.sliderControlWrapper && (_this13.sliderFirstItemNode = _this13.slider.querySelector(".slideshow__slide"), 0 < _this13.sliderItemsToShow.length && (_this13.currentPage = 1), _this13.announcementBarSlider = _this13.querySelector(".announcement-bar-slider"), _this13.announcerBarAnimationDelay = _this13.announcementBarSlider ? 250 : 0, _this13.sliderControlLinksArray = Array.from(_this13.sliderControlWrapper.querySelectorAll(".slider-counter__link")), _this13.sliderControlLinksArray.forEach(function (t) {
      return t.addEventListener("click", _this13.linkToSlide.bind(_assertThisInitialized(_this13)));
    }), _this13.slider.addEventListener("scroll", _this13.setSlideVisibility.bind(_assertThisInitialized(_this13))), _this13.setSlideVisibility(), _this13.announcementBarSlider && (_this13.announcementBarArrowButtonWasClicked = !1, _this13.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)"), _this13.reducedMotion.addEventListener("change", function () {
      "true" === _this13.slider.getAttribute("data-autoplay") && _this13.setAutoPlay();
    }), [_this13.prevButton, _this13.nextButton].forEach(function (t) {
      t.addEventListener("click", function () {
        _this13.announcementBarArrowButtonWasClicked = !0;
      }, {
        once: !0
      });
    })), "true" === _this13.slider.getAttribute("data-autoplay")) && _this13.setAutoPlay();
    return _this13;
  }
  _inherits(SlideshowComponent, _SliderComponent);
  return _createClass(SlideshowComponent, [{
    key: "setAutoPlay",
    value: function setAutoPlay() {
      this.autoplaySpeed = 1e3 * this.slider.dataset.speed, this.addEventListener("mouseover", this.focusInHandling.bind(this)), this.addEventListener("mouseleave", this.focusOutHandling.bind(this)), this.addEventListener("focusin", this.focusInHandling.bind(this)), this.addEventListener("focusout", this.focusOutHandling.bind(this)), this.querySelector(".slideshow__autoplay") ? (this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay"), this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this)), this.autoplayButtonIsSetToPlay = !0, this.play()) : this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(t) {
      _get(_getPrototypeOf(SlideshowComponent.prototype), "onButtonClick", this).call(this, t), this.wasClicked = !0;
      var e = 1 === this.currentPage,
        i = this.currentPage === this.sliderItemsToShow.length;
      (e || i) && (e && "previous" === t.currentTarget.name ? this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length : i && "next" === t.currentTarget.name && (this.slideScrollPosition = 0), this.setSlidePosition(this.slideScrollPosition)), this.applyAnimationToAnnouncementBar(t.currentTarget.name);
    }
  }, {
    key: "setSlidePosition",
    value: function setSlidePosition(t) {
      var _this14 = this;
      this.setPositionTimeout && clearTimeout(this.setPositionTimeout), this.setPositionTimeout = setTimeout(function () {
        _this14.slider.scrollTo({
          left: t
        });
      }, this.announcerBarAnimationDelay);
    }
  }, {
    key: "update",
    value: function update() {
      _get(_getPrototypeOf(SlideshowComponent.prototype), "update", this).call(this), this.sliderControlButtons = this.querySelectorAll(".slider-counter__link"), this.prevButton.removeAttribute("disabled"), this.sliderControlButtons.length && (this.sliderControlButtons.forEach(function (t) {
        t.classList.remove("slider-counter__link--active"), t.removeAttribute("aria-current");
      }), this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active"), this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", !0));
    }
  }, {
    key: "autoPlayToggle",
    value: function autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay), this.autoplayButtonIsSetToPlay ? this.pause() : this.play(), this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
  }, {
    key: "focusOutHandling",
    value: function focusOutHandling(t) {
      this.sliderAutoplayButton ? (t = t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target), this.autoplayButtonIsSetToPlay && !t && this.play()) : this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || this.play();
    }
  }, {
    key: "focusInHandling",
    value: function focusInHandling(t) {
      this.sliderAutoplayButton ? (t.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(t.target)) && this.autoplayButtonIsSetToPlay ? this.play() : this.autoplayButtonIsSetToPlay && this.pause() : this.announcementBarSlider.contains(t.target) && this.pause();
    }
  }, {
    key: "play",
    value: function play() {
      this.slider.setAttribute("aria-live", "off"), clearInterval(this.autoplay), this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  }, {
    key: "pause",
    value: function pause() {
      this.slider.setAttribute("aria-live", "polite"), clearInterval(this.autoplay);
    }
  }, {
    key: "togglePlayButtonState",
    value: function togglePlayButtonState(t) {
      t ? (this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow)) : (this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused"), this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow));
    }
  }, {
    key: "autoRotateSlides",
    value: function autoRotateSlides() {
      var t = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
      this.setSlidePosition(t), this.applyAnimationToAnnouncementBar();
    }
  }, {
    key: "setSlideVisibility",
    value: function setSlideVisibility(t) {
      var _this15 = this;
      this.sliderItemsToShow.forEach(function (t, e) {
        var i = t.querySelectorAll("a");
        e === _this15.currentPage - 1 ? (i.length && i.forEach(function (t) {
          t.removeAttribute("tabindex");
        }), t.setAttribute("aria-hidden", "false"), t.removeAttribute("tabindex")) : (i.length && i.forEach(function (t) {
          t.setAttribute("tabindex", "-1");
        }), t.setAttribute("aria-hidden", "true"), t.setAttribute("tabindex", "-1"));
      }), this.wasClicked = !1;
    }
  }, {
    key: "applyAnimationToAnnouncementBar",
    value: function applyAnimationToAnnouncementBar() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "next";
      if (this.announcementBarSlider) {
        var e = this.sliderItems.length,
          i = this.currentPage - 1,
          s = (i + ("next" === t ? 1 : -1)) % e;
        var n = this.sliderItems[-1 == s ? e - 1 : s],
          r = this.sliderItems[i],
          o = "announcement-bar-slider--fade-in",
          a = "announcement-bar-slider--fade-out",
          l = "next" === t && !(i == e - 1) || "previous" === t && 0 == i ? "next" : "previous";
        r.classList.add(a + "-" + l), n.classList.add(o + "-" + l), setTimeout(function () {
          r.classList.remove(a + "-" + l), n.classList.remove(o + "-" + l);
        }, 2 * this.announcerBarAnimationDelay);
      }
    }
  }, {
    key: "linkToSlide",
    value: function linkToSlide(t) {
      t.preventDefault();
      t = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(t.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: t
      });
    }
  }]);
}(SliderComponent);
customElements.define("slideshow-component", SlideshowComponent);
var VariantSelects = /*#__PURE__*/function (_HTMLElement7) {
  function VariantSelects() {
    var _this16;
    _classCallCheck(this, VariantSelects);
    _this16 = _callSuper(this, VariantSelects), _this16.addEventListener("change", _this16.onVariantChange);
    return _this16;
  }
  _inherits(VariantSelects, _HTMLElement7);
  return _createClass(VariantSelects, [{
    key: "onVariantChange",
    value: function onVariantChange() {
      this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.removeErrorMessage(), this.updateVariantStatuses(), this.currentVariant ? (this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      this.options = Array.from(this.querySelectorAll("select"), function (t) {
        return t.value;
      });
    }
  }, {
    key: "updateMasterId",
    value: function updateMasterId() {
      var _this17 = this;
      this.currentVariant = this.getVariantData().find(function (t) {
        return !t.options.map(function (t, e) {
          return _this17.options[e] === t;
        }).includes(!1);
      });
    }
  }, {
    key: "updateMedia",
    value: function updateMedia() {
      var _this18 = this;
      var t, e;
      this.currentVariant && this.currentVariant.featured_media && (document.querySelectorAll("[id^=\"MediaGallery-".concat(this.dataset.section, "\"]")).forEach(function (t) {
        return t.setActiveMedia(_this18.dataset.section + "-" + _this18.currentVariant.featured_media.id, !0);
      }), t = document.querySelector("#ProductModal-".concat(this.dataset.section, " .product-media-modal__content"))) && (e = t.querySelector("[data-media-id=\"".concat(this.currentVariant.featured_media.id, "\"]")), t.prepend(e));
    }
  }, {
    key: "updateURL",
    value: function updateURL() {
      this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
    }
  }, {
    key: "updateShareUrl",
    value: function updateShareUrl() {
      var t = document.getElementById("Share-" + this.dataset.section);
      t && t.updateUrl && t.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
    }
  }, {
    key: "updateVariantInput",
    value: function updateVariantInput() {
      var _this19 = this;
      document.querySelectorAll("#product-form-".concat(this.dataset.section, ", #product-form-installment-") + this.dataset.section).forEach(function (t) {
        t = t.querySelector('input[name="id"]');
        t.value = _this19.currentVariant.id, t.dispatchEvent(new Event("change", {
          bubbles: !0
        }));
      });
    }
  }, {
    key: "updateVariantStatuses",
    value: function updateVariantStatuses() {
      var _this20 = this;
      var n = this.variantData.filter(function (t) {
          return _this20.querySelector(":checked").value === t.option1;
        }),
        r = _toConsumableArray(this.querySelectorAll(".product-form__input"));
      r.forEach(function (t, e) {
        if (0 !== e) {
          t = _toConsumableArray(t.querySelectorAll('input[type="radio"], option'));
          var s = r[e - 1].querySelector(":checked").value;
          var i = n.filter(function (t) {
            return t.available && t["option" + e] === s;
          }).map(function (t) {
            return t["option" + (e + 1)];
          });
          _this20.setInputAvailability(t, i);
        }
      });
    }
  }, {
    key: "setInputAvailability",
    value: function setInputAvailability(t, e) {
      t.forEach(function (t) {
        e.includes(t.getAttribute("value")) ? t.innerText = t.getAttribute("value") : t.innerText = window.variantStrings.unavailable_with_option.replace("[value]", t.getAttribute("value"));
      });
    }
  }, {
    key: "updatePickupAvailability",
    value: function updatePickupAvailability() {
      var t = document.querySelector("pickup-availability");
      t && (this.currentVariant && this.currentVariant.available ? t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"), t.innerHTML = ""));
    }
  }, {
    key: "removeErrorMessage",
    value: function removeErrorMessage() {
      var t = this.closest("section");
      t && (t = t.querySelector("product-form")) && t.handleErrorMessage();
    }
  }, {
    key: "renderProductInfo",
    value: function renderProductInfo() {
      var _this21 = this;
      var m = this.currentVariant.id,
        p = this.dataset.originalSection || this.dataset.section;
      fetch("".concat(this.dataset.url, "?variant=").concat(m, "&section_id=") + (this.dataset.originalSection || this.dataset.section)).then(function (t) {
        return t.text();
      }).then(function (t) {
        var e, i, s, n, r, o, a, l, d, u, c, h;
        _this21.currentVariant.id === m && (t = new DOMParser().parseFromString(t, "text/html"), e = document.getElementById("price-" + _this21.dataset.section), i = t.getElementById("price-" + (_this21.dataset.originalSection || _this21.dataset.section)), s = t.getElementById("Sku-" + (_this21.dataset.originalSection || _this21.dataset.section)), n = document.getElementById("Sku-" + _this21.dataset.section), r = t.getElementById("Inventory-" + (_this21.dataset.originalSection || _this21.dataset.section)), o = document.getElementById("Inventory-" + _this21.dataset.section), a = t.getElementById("Volume-" + (_this21.dataset.originalSection || _this21.dataset.section)), l = document.getElementById("Price-Per-Item-" + _this21.dataset.section), d = t.getElementById("Price-Per-Item-" + (_this21.dataset.originalSection || _this21.dataset.section)), u = document.getElementById("Volume-" + _this21.dataset.section), h = document.getElementById("Quantity-Rules-" + _this21.dataset.section), (c = document.getElementById("Volume-Note-" + _this21.dataset.section)) && c.classList.remove("hidden"), u && u.classList.remove("hidden"), h && h.classList.remove("hidden"), i && e && (e.innerHTML = i.innerHTML), r && o && (o.innerHTML = r.innerHTML), s && n && (n.innerHTML = s.innerHTML, n.classList.toggle("hidden", s.classList.contains("hidden"))), a && u && (u.innerHTML = a.innerHTML), d && l && (l.innerHTML = d.innerHTML, l.classList.toggle("hidden", d.classList.contains("hidden"))), (c = document.getElementById("price-" + _this21.dataset.section)) && c.classList.remove("hidden"), o && o.classList.toggle("hidden", "" === r.innerText), h = t.getElementById("ProductSubmitButton-" + p), _this21.toggleAddButton(!h || h.hasAttribute("disabled"), window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: p,
            html: t,
            variant: _this21.currentVariant
          }
        }));
      });
    }
  }, {
    key: "toggleAddButton",
    value: function toggleAddButton() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var e = arguments.length > 1 ? arguments[1] : undefined;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      var s,
        n = document.getElementById("product-form-" + this.dataset.section);
      n && (s = n.querySelector('[name="add"]'), n = n.querySelector('[name="add"] > span'), s) && (t ? (s.setAttribute("disabled", "disabled"), e && (n.textContent = e)) : (s.removeAttribute("disabled"), n.textContent = window.variantStrings.addToCart));
    }
  }, {
    key: "setUnavailable",
    value: function setUnavailable() {
      var t = document.getElementById("product-form-" + this.dataset.section),
        e = t.querySelector('[name="add"]'),
        t = t.querySelector('[name="add"] > span'),
        i = document.getElementById("price-" + this.dataset.section),
        s = document.getElementById("Inventory-" + this.dataset.section),
        n = document.getElementById("Sku-" + this.dataset.section),
        r = document.getElementById("Price-Per-Item-" + this.dataset.section),
        o = document.getElementById("Volume-Note-" + this.dataset.section),
        a = document.getElementById("Volume-" + this.dataset.section),
        l = document.getElementById("Quantity-Rules-" + this.dataset.section);
      e && (t.textContent = window.variantStrings.unavailable, i && i.classList.add("hidden"), s && s.classList.add("hidden"), n && n.classList.add("hidden"), r && r.classList.add("hidden"), o && o.classList.add("hidden"), a && a.classList.add("hidden"), l) && l.classList.add("hidden");
    }
  }, {
    key: "getVariantData",
    value: function getVariantData() {
      return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("variant-selects", VariantSelects);
var VariantRadios = /*#__PURE__*/function (_VariantSelects) {
  function VariantRadios() {
    _classCallCheck(this, VariantRadios);
    return _callSuper(this, VariantRadios);
  }
  _inherits(VariantRadios, _VariantSelects);
  return _createClass(VariantRadios, [{
    key: "setInputAvailability",
    value: function setInputAvailability(t, e) {
      t.forEach(function (t) {
        e.includes(t.getAttribute("value")) ? t.classList.remove("disabled") : t.classList.add("disabled");
      });
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      var t = Array.from(this.querySelectorAll("fieldset"));
      this.options = t.map(function (t) {
        return Array.from(t.querySelectorAll("input")).find(function (t) {
          return t.checked;
        }).value;
      });
    }
  }]);
}(VariantSelects);
customElements.define("variant-radios", VariantRadios);
var ProductRecommendations = /*#__PURE__*/function (_HTMLElement8) {
  function ProductRecommendations() {
    _classCallCheck(this, ProductRecommendations);
    return _callSuper(this, ProductRecommendations);
  }
  _inherits(ProductRecommendations, _HTMLElement8);
  return _createClass(ProductRecommendations, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this22 = this;
      new IntersectionObserver(function (t, e) {
        t[0].isIntersecting && (e.unobserve(_this22), fetch(_this22.dataset.url).then(function (t) {
          return t.text();
        }).then(function (t) {
          var e = document.createElement("div"),
            t = (e.innerHTML = t, e.querySelector("product-recommendations"));
          t && t.innerHTML.trim().length && (_this22.innerHTML = t.innerHTML), !_this22.querySelector("slideshow-component") && _this22.classList.contains("complementary-products") && _this22.remove(), e.querySelector(".grid__item") && _this22.classList.add("product-recommendations--loaded");
        })["catch"](function (t) {
          console.error(t);
        }));
      }.bind(this), {
        rootMargin: "0px 0px 400px 0px"
      }).observe(this);
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("product-recommendations", ProductRecommendations);